import { useEffect, useRef, useState } from "react";
import api from "../services/api";
import Swal from "sweetalert2";
import useCart from "../hooks/useCart";
import Select from "react-select";

export default function PostForm({ onSuccess }) {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [showPayModal, setShowPayModal] = useState(false);
  const [cash, setCash] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tipoDocumento, setTipoDocumento] = useState("01");
  const [showManualModal, setShowManualModal] = useState(false);
  const [manualItem, setManualItem] = useState({ descripcion: "", precio: "", cantidad: 1 });

  const inputRef = useRef(null);

  const {
    cart,
    subtotal,
    addProductByCode,
    addProduct,
    addManualItem,
    updateQuantity,
    removeItem,
    clearCart
  } = useCart();

  // 🔹 Cargar clientes
  useEffect(() => {
    api.get("/clients").then(res => {
      const data = res.data.data ?? res.data;
      setClients(data);

      const varios = data.find(
        c => c.nombre.toUpperCase() === "CLIENTES VARIOS"
      );

      if (varios) {
        setSelectedClient({ value: varios.id, label: varios.nombre });
      }
    });
  }, []);

  // 🔹 Cargar productos
  useEffect(() => {
    api.get("/products").then(res => {
      const data = res.data.data ?? res.data; // ✅ Define data primero
      setProducts(data); // ✅ Solo un setProducts
    });
  }, []);

  // 🔹 Foco permanente
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // 🔹 Buscar mientras escribe ✅ CORREGIDO
  useEffect(() => {
    if (!search) {
      setResults([]);
      return;
    }

    const q = search.toLowerCase();

    setResults(
      products
        .filter(p => {
          // ✅ Buscar por codigo (campo real en tu BD)
          const matchCodigo = p.codigo?.toLowerCase().includes(q);
          
          // ✅ Buscar por nombre
          const matchNombre = p.nombre?.toLowerCase().includes(q);
          
          return matchCodigo || matchNombre;
        })
        .slice(0, 6)
    );
  }, [search, products]);

  // ✅ Actualizar tipo de documento cuando cambia el cliente
  useEffect(() => {
    if (selectedClient) {
      const cliente = clients.find(c => c.id === selectedClient.value);
      if (cliente) {
        setTipoDocumento(cliente.tipo_cliente === "Contribuyente" ? "03" : "01");
      }
    }
  }, [selectedClient, clients]);

  // 🔹 Enter (escáner) ✅ CORREGIDO
  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (results.length > 0) {
        // ✅ Agregar el primer resultado directamente
        addProduct(results[0]);
      } else {
        await addProductByCode(search);
      }

      setSearch("");
      setResults([]);
    }
  };

  // 🔹 Click en resultado
  const handleSelect = (product) => {
    addProduct(product);
    setSearch("");
    setResults([]);
    inputRef.current.focus();
  };

  // 🔹 Construir payload seguro
const buildSafePayload = (clientId, cartItems, cashInput, tipoDoc) => {
  const cashAmount = parseFloat(cashInput) || 0;

  const clientFull = clients.find(c => c.id === Number(clientId));
  if (!clientFull) throw new Error("Cliente no encontrado");

const details = cartItems.map(item => ({
    product_id: item.product_id ? Number(item.product_id) : null,
    presentation_id: item.presentation_id || null,
    cantidad: Number(item.cantidad) || 1,
    precio_unitario: Number(item.precio_unitario) || 0,
    nombre: item.es_manual ? item.nombre : undefined,
    es_manual: item.es_manual || false
}));

  if (details.length === 0) {
    throw new Error("El carrito debe tener al menos un producto");
  }

  // Totales
  const subtotal = details.reduce(
    (acc, i) => acc + i.cantidad * i.precio_unitario,
    0
  );
  const iva_total = 0;
  const total_gravado = subtotal; 
  const total_exento = 0;
  const monto_final = subtotal + iva_total;

  const fechaMySQL = new Date().toISOString().slice(0, 19).replace("T", " ");

  return {
    client_id: Number(clientId),
    tipo_cliente: clientFull.tipo_cliente.toLowerCase().replace(" ", "_"),
    fecha_venta: fechaMySQL,
    details,
    subtotal,
    total_gravado,
    total_exento,
    iva_total,
    monto_final,
    condicion_operacion: "CONTADO",
    estado: "PENDIENTE",
    cash: cashAmount,
    change: cashAmount - subtotal,
    tipo_documento: tipoDoc
  };
};

  // 🔹 Facturar
  const submitSale = async () => {
    if (!selectedClient) {
      return Swal.fire("Error", "Seleccione un cliente", "warning");
    }

    if (cart.length === 0) {
      return Swal.fire("Error", "Carrito vacío", "warning");
    }

    if (Number(cash) < subtotal) {
      return Swal.fire("Error", "Monto insuficiente", "warning");
    }

    const clienteFull = clients.find(c => c.id === selectedClient.value);
    if (tipoDocumento === "03" && clienteFull?.tipo_cliente !== "Contribuyente") {
      return Swal.fire(
        "Error",
        "No se puede emitir Crédito Fiscal a un cliente No Contribuyente",
        "error"
      );
    }

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = buildSafePayload(selectedClient.value, cart, cash, tipoDocumento);
      const saleRes = await api.post("/sales", payload);
      const saleData = saleRes.data.data;

      onSuccess({
        ...saleData,
        cash: payload.cash,
        change: payload.change
      });

      clearCart();
      setCash("");
      setShowPayModal(false);

    } catch (error) {
      console.error("ERROR FACTURAR COMPLETO:", error.response?.data || error);

      Swal.fire(
        "Error",
        error.response?.data?.message || "Error al facturar",
        "error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const clientOptions = clients.map(c => ({
    value: c.id,
    label: c.nombre
  }));

  const clienteFull = selectedClient ? clients.find(c => c.id === selectedClient.value) : null;
  const puedeElegirTipoFactura = clienteFull?.tipo_cliente === "Contribuyente";

  return (
    <>
      {/* Cliente */}
      <div className="form-group">
        <label className="form-label">Cliente</label>
        <Select
          options={clientOptions}
          value={selectedClient}
          onChange={setSelectedClient}
          placeholder="Seleccionar cliente..."
          styles={{
            control: (base) => ({
              ...base,
              borderColor: '#e2e8f0',
              borderWidth: '2px',
              borderRadius: '10px',
              padding: '4px',
              '&:hover': { borderColor: '#667eea' }
            })
          }}
        />
      </div>

      {/* Input POS */}
      <div className="form-group" style={{ position: 'relative' }}>
        <label className="form-label">Buscar Producto</label>
        <input
          ref={inputRef}
          className="form-control"
          placeholder="Escanear o buscar producto..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <div style={{ marginTop: '8px' }}>
  <button
    type="button"
    className="btn btn-secondary btn-sm"
    onClick={() => setShowManualModal(true)}
  >
    ➕ Agregar producto manual
  </button>
</div>
        {results.length > 0 && (
          <div
            style={{
              position: 'absolute',
              width: '100%',
              zIndex: 1000,
              marginTop: '4px'
            }}
          >
            <div className="card" style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {results.map(p => (
                <div
                  key={p.id}
                  onClick={() => handleSelect(p)}
                  style={{
                    padding: '12px 16px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #e2e8f0',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
                  onMouseLeave={(e) => e.target.style.background = 'white'}
                >
                  {/* ✅ CORREGIDO: Mostrar codigo (no codigo_barra) */}
                  <strong style={{ color: 'var(--primary-color)' }}>
                    {p.codigo}
                  </strong>
                  {' — '}
                  <span style={{ color: 'var(--text-primary)' }}>{p.nombre}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Carrito */}
      <div className="table-container mt-4">
        <table className="table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Descripción</th>
              <th style={{ width: 100, textAlign: 'center' }}>Cantidad</th>
              <th style={{ width: 120, textAlign: 'right' }}>Precio Unit.</th>
              <th style={{ width: 120, textAlign: 'right' }}>Total</th>
              <th style={{ width: 80, textAlign: 'center' }}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {cart.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center" style={{ padding: '32px' }}>
                  <p style={{ color: 'var(--text-secondary)', margin: 0 }}>
                    El carrito está vacío. Escanea o busca productos para agregar.
                  </p>
                </td>
              </tr>
            )}
            {cart.map(p => (
              <tr key={p.uniqueKey}>
                <td>
                  <strong style={{ color: 'var(--text-primary)' }}>
                    {p.codigo}
                  </strong>
                </td>
                <td>{p.nombre}</td>
                <td style={{ textAlign: 'center' }}>
                  <input
                type="number"
                min="1"
                className="form-control text-center"
                value={p.cantidad}
                onChange={e =>
                updateQuantity(p.uniqueKey, e.target.value)
                  }
                style={{ padding: '8px' }}

                  />
                </td>
                <td style={{ textAlign: 'right' }}>${p.precio_unitario.toFixed(2)}</td>
                <td style={{ textAlign: 'right' }}>
                  <strong style={{ color: 'var(--primary-color)' }}>
                    ${p.subtotal.toFixed(2)}
                  </strong>
                </td>
                <td className="text-center">
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => removeItem(p.uniqueKey)}
                  title="Eliminar producto"
                >
                    ✕
                </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Total */}
      <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
        <h3 style={{ color: 'var(--text-primary)', margin: 0 }}>
          Total a pagar:
        </h3>
        <h2 style={{ 
          color: 'var(--primary-color)', 
          margin: 0,
          fontSize: '32px',
          fontWeight: '700'
        }}>
          ${subtotal.toFixed(2)}
        </h2>
      </div>

      <button
        className="btn btn-success btn-lg"
        disabled={cart.length === 0}
        onClick={() => setShowPayModal(true)}
        style={{ width: '100%' }}
      >
        💳 Cobrar / Facturar
      </button>

      {/* Modal Cobro */}
      {showPayModal && (
        <>
          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content card">

                <div className="card-header">
                  <h3 className="card-title" style={{ margin: 0 }}>💰 Cobro</h3>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setShowPayModal(false);
                      setCash("");
                    }}
                  >
                    ✕
                  </button>
                </div>

                <div className="card-body">
                  <div className="alert alert-info mb-3">
                    <strong>Cliente:</strong> {clienteFull?.nombre || "No seleccionado"}
                    {clienteFull && (
                      <span style={{ marginLeft: '8px', fontSize: '13px', color: '#0369a1' }}>
                        ({clienteFull.tipo_cliente})
                      </span>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label" style={{ fontWeight: 600 }}>
                      Tipo de Factura
                    </label>

                    {!puedeElegirTipoFactura ? (
                      <div style={{
                        padding: '12px',
                        background: '#f0f9ff',
                        borderRadius: '8px',
                        border: '2px solid #0ea5e9'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <input type="radio" checked disabled />
                          <span style={{ fontWeight: 600 }}>📄 Consumidor Final</span>
                        </div>
                        <small style={{ color: '#0369a1', display: 'block', marginTop: '4px' }}>
                          Este cliente solo puede recibir factura de consumidor final
                        </small>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        <div
                          onClick={() => setTipoDocumento("01")}
                          style={{
                            padding: '12px',
                            background: tipoDocumento === "01" ? '#f0f9ff' : '#f7fafc',
                            border: tipoDocumento === "01" ? '2px solid #0ea5e9' : '1px solid #e2e8f0',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                              type="radio"
                              checked={tipoDocumento === "01"}
                              onChange={() => setTipoDocumento("01")}
                            />
                            <span style={{ fontWeight: 600 }}>📄 Consumidor Final</span>
                          </div>
                          <small style={{ color: '#718096', display: 'block', marginTop: '4px', marginLeft: '24px' }}>
                            Factura simple sin deducción de IVA
                          </small>
                        </div>

                        <div
                          onClick={() => setTipoDocumento("03")}
                          style={{
                            padding: '12px',
                            background: tipoDocumento === "03" ? '#f0fdf4' : '#f7fafc',
                            border: tipoDocumento === "03" ? '2px solid #10b981' : '1px solid #e2e8f0',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                              type="radio"
                              checked={tipoDocumento === "03"}
                              onChange={() => setTipoDocumento("03")}
                            />
                            <span style={{ fontWeight: 600 }}>💼 Crédito Fiscal</span>
                          </div>
                          <small style={{ color: '#718096', display: 'block', marginTop: '4px', marginLeft: '24px' }}>
                            Permite al cliente deducir el IVA
                          </small>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="alert alert-success">
                    <strong>Total a pagar:</strong> ${subtotal.toFixed(2)}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Monto Recibido</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      className="form-control"
                      placeholder="0.00"
                      value={cash}
                      autoFocus
                      onChange={e => {
                        const value = e.target.value;
                        // Permitir solo números y un punto decimal
                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                          setCash(value);
                        }
                      }}
                      onKeyDown={e => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          // Solo facturar si el monto es válido y suficiente
                          if (cash && Number(cash) >= subtotal && !isSubmitting) {
                            submitSale();
                          }
                        }
                      }}
                      style={{ fontSize: '18px', fontWeight: '600' }}
                    />
                  </div>

                  {cash !== "" && (
                    <div className={`alert ${
                      Number(cash) >= subtotal
                        ? "alert-success"
                        : "alert-danger"
                    } mt-3`}>
                      <strong>
                        {Number(cash) >= subtotal
                          ? `✓ Vuelto: $${(cash - subtotal).toFixed(2)}`
                          : "⚠ Monto insuficiente"}
                      </strong>
                    </div>
                  )}
                </div>

                <div className="card-body" style={{ 
                  borderTop: '2px solid #e2e8f0',
                  display: 'flex',
                  gap: '12px',
                  paddingTop: 'var(--spacing-md)'
                }}>
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowPayModal(false);
                      setCash("");
                    }}
                    style={{ flex: 1 }}
                  >
                    Cancelar
                  </button>

                  <button
                    className="btn btn-success"
                    disabled={!cash || Number(cash) < subtotal || isSubmitting}
                    onClick={submitSale}
                    style={{ flex: 1 }}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Procesando...
                      </>
                    ) : (
                      '✓ Facturar'
                    )}
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
 )}

      {/* Modal Producto Manual */}
      {showManualModal && (
        <>
          <div className="modal fade show d-block" style={{ zIndex: 1060 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content card">

                <div className="card-header">
                  <h3 className="card-title" style={{ margin: 0 }}>➕ Producto Manual</h3>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setShowManualModal(false);
                      setManualItem({ descripcion: "", precio: "", cantidad: 1 });
                    }}
                  >✕</button>
                </div>

                <div className="card-body">
                  <div className="form-group mb-3">
                    <label className="form-label">Descripción *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Ej: Camiseta talla M azul"
                      value={manualItem.descripcion}
                      autoFocus
                      onChange={e => setManualItem(prev => ({ ...prev, descripcion: e.target.value }))}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label">Precio Unitario *</label>
                    <input
                      type="number"
                      min="0.01"
                      step="0.01"
                      className="form-control"
                      placeholder="0.00"
                      value={manualItem.precio}
                      onChange={e => setManualItem(prev => ({ ...prev, precio: e.target.value }))}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label">Cantidad *</label>
                    <input
                      type="number"
                      min="1"
                      className="form-control"
                      value={manualItem.cantidad}
                      onChange={e => setManualItem(prev => ({ ...prev, cantidad: e.target.value }))}
                    />
                  </div>

                  {manualItem.precio && manualItem.cantidad && (
                    <div className="alert alert-info">
                      <strong>Total línea: </strong>
                      ${(Number(manualItem.precio) * Number(manualItem.cantidad)).toFixed(2)}
                    </div>
                  )}
                </div>

                <div className="card-body" style={{
                  borderTop: '2px solid #e2e8f0',
                  display: 'flex',
                  gap: '12px',
                  paddingTop: 'var(--spacing-md)'
                }}>
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowManualModal(false);
                      setManualItem({ descripcion: "", precio: "", cantidad: 1 });
                    }}
                    style={{ flex: 1 }}
                  >Cancelar</button>

                  <button
                    className="btn btn-success"
                    style={{ flex: 1 }}
                    disabled={!manualItem.descripcion || !manualItem.precio || Number(manualItem.precio) <= 0}
                    onClick={() => {
                      addManualItem(manualItem.descripcion, manualItem.precio, manualItem.cantidad);
                      setShowManualModal(false);
                      setManualItem({ descripcion: "", precio: "", cantidad: 1 });
                      inputRef.current?.focus();
                    }}
                  >✓ Agregar al carrito</button>
                </div>

              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" style={{ zIndex: 1055 }}></div>
        </>
      )}
    </>
  );
}